import React from 'react';
import CapabilitiesPage from './CapabilitiesPage';
import StandardQuestionsPage from './StandardQuestionsPage';
import UnknownPage from './UnknownPage';

function Page({ page }) {
  switch (page.type) {
    case 'capability-questions':
      return <CapabilitiesPage page={page} />;
    case 'standard-questions':
      return <StandardQuestionsPage page={page} />;
    default:
      return <UnknownPage page={page} />;
  }
}

export default Page;
